export default __webpack_public_path__ + "static/media/kioskfx.4ab560de.mp3";